import { ChronoIcon } from "@images/svgIcons/chronoIcon"
import { displayTotalTime, getTrainingChronoTitle } from "@modules/chrono/chronoUtils"
import { RpeTag } from "@modules/sessionBlock/exercises/components/rpeTag"
import { Exercise } from "@modules/sessionBlock/exercises/exerciseTypes"
import { getDisplayExerciseCategory } from "@modules/sessionBlock/exercises/exerciseUtils"
import { HUText } from "@modules/ui/components/huText"
import { HURichTextView } from "@modules/ui/components/richText/huRichTextView"
import { formatTextToRichText } from "@modules/ui/components/richText/richTextUtils"
import { useTheme } from "styled-components"

export const FullscreenExerciseDetails: React.FC<{
  exercise: Exercise
}> = ({ exercise }) => {
  const theme = useTheme()

  return (
    <div className="flex flex-column flex-1">
      <HUText fontStyle="HL" className="mb-4">
        {getDisplayExerciseCategory(exercise.category, exercise.otherCategory)}
      </HUText>
      <div className="flex mb-4 align-items-center">
        {exercise.chrono?.type && (
          <>
            <ChronoIcon color={theme.neutralColor700} width={25} height={25} />
            <div className="flex flex-column mr-4">
              <HUText fontStyle="TS" className="event-content ml-2" color={theme.neutralColor700}>
                {getTrainingChronoTitle(exercise.chrono.type)}
              </HUText>
              <HUText fontStyle="TS" className="event-content ml-2" color={theme.neutralColor700}>
                {displayTotalTime(exercise.chrono)}
              </HUText>
            </div>
          </>
        )}
        {exercise.rpe && <RpeTag exercise={exercise} />}
      </div>
      <HURichTextView value={formatTextToRichText(exercise.description)} paragrapheFontStyle="TL" />
    </div>
  )
}
